import * as React from 'react'
import type { SVGProps } from 'react'
const SvgArrowBack = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.25265 9.07075C7.64317 8.68023 7.64317 8.04706 7.25265 7.65654C6.86213 7.26602 6.22896 7.26602 5.83844 7.65654L2.20882 11.2862C2.18444 11.3101 2.16128 11.3352 2.13945 11.3615C2.08149 11.4312 2.03448 11.507 1.99841 11.5865C1.9411 11.7125 1.90918 11.8525 1.90918 11.9999C1.90918 12.003 1.90919 12.0061 1.90922 12.0092C1.91033 12.1313 1.93332 12.2482 1.97445 12.3561C2.02311 12.484 2.09899 12.604 2.20207 12.7071L5.83844 16.3435C6.22896 16.734 6.86213 16.734 7.25265 16.3435C7.64317 15.953 7.64317 15.3198 7.25265 14.9293L5.32333 12.9999H21.091C21.6433 12.9999 22.091 12.5522 22.091 11.9999C22.091 11.4477 21.6433 10.9999 21.091 10.9999H5.32346L7.25265 9.07075Z"
      fill="#190900"
    />
  </svg>
)
export default SvgArrowBack
